module.exports = __webpack_public_path__ + "img/corner@3x.4d7ecf2e.png";